import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import documentModel from "@/models/document/document";
import router from "@/router";
import store from "@/store";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import usePagination from "@/views/components/pagination/usePagination";
import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api";

export default function useDocumentCampaignList() {
  const { fetchDocumentContainerList } = documentModel();

  const { pagination, onPageChange, onFilterEntity } = usePagination();
  const { openModal, closeModal } = useModal();
  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal();

  const loading = reactive({
    tableData: false,
  });
  
  const modalPopup = reactive({
    report: false,
  });

  const onOpenExportModal = () => {
    modalPopup.report = true;
    openModal();
  };

  const closeReportModal = () => {
    modalPopup.report = false;
    closeModal();
  };
  const campaignSelect = ref(null);

  const fields = [
    { key: "seq", label: "No" },
    { key: "name", label: "Campaign Name" },
    { key: "document_qty", label: "Qty." },
    { key: "alt_reference", label: "Ref. Campaign" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ];

  const statusOption = ref([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ]);

  const status = ref(0);

  const modalType = reactive({
    createCampaign: false,
  });

  const onCloseModalCampaign = () => {
    closeModal();
    modalType.createCampaign = false;
    fetchDocumentCampaignList();
  };

  const onOpenModalCreateCampaign = (campaignId) => {
    campaignSelect.value = campaignId;
    modalType.createCampaign = true;
    openModal();
  };

  const documentListTable = reactive({
    payload: [],
  });

  const fetchDocumentCampaignList = () => {
    loading.tableData = true;
    fetchDocumentContainerList.payload.Page = pagination.currentPage;
    fetchDocumentContainerList.payload.Limit = pagination.perPage;
    fetchDocumentContainerList.payload.Filters = filters;
    store
      .dispatch("api/apiRequest", fetchDocumentContainerList)
      .then((response) => {
        documentListTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchDocumentCampaignList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchDocumentCampaignList();
    },
    { deep: true }
  );

  const campaignActionList = reactive({
    detail: {
      label: "Document List",
      value: 1,
      icon: "IconDetail",
      display: true,
    },
    edit: {
      label: "Edit",
      value: 2,
      icon: "EditIcon",
      display: true,
    },
  });

  const resolveMappingTableAction = (type, item) => {
    switch (type) {
      case 1:
        router
          .push(`/campaign/list/document-detail/${item.item.container_id}`)
          .catch(() => {});
        return;
      case 2:
        onOpenModalCreateCampaign(item.item.container_id);

      default:
    }
  };

  onBeforeMount(() => {
    fetchDocumentCampaignList();
  });

  return {
    fields,
    loading,
    statusOption,
    status,
    documentListTable,
    pagination,
    modalType,
    campaignActionList,
    campaignSelect,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onCloseModalCampaign,
    onOpenModalCreateCampaign,
    onSelectFilter,
    resolveMappingTableAction,
    modalPopup,
    onOpenExportModal,
    closeReportModal,
  };
}
